import React from "react";
import styles from "./NewIcon.module.css";

const NewICon: React.FC = () => {
  return <div className={styles.icon}>New</div>;
};

export default NewICon;
